export const parseErrorMsg = (err: unknown): any => {
  const typedErr = err as {
    response?: { data?: { message?: string } };
    message?: string;
    toString?: () => string;
  };
  const apiMessage = typedErr?.response?.data?.message;
  if (apiMessage) {
    return apiMessage;
  }

  if (typedErr?.toString?.().includes('403')) {
    return `Access Denied - ${typedErr.toString()}`;
  }

  return typedErr?.message || typedErr?.toString?.() || 'Unknown error';
};
